/* eslint-disable */


/**
 * Create styles for `<OrderTitle />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderTitle />` styles
 */
const orderTitleStyles = ({ theme }) => ({
  wrapText: {
    overflowX: `hidden`,
    textOverflow: `ellipsis`,
    whiteSpace: `nowrap`,
  },
});

export default orderTitleStyles;
